import React from 'react'
import {Button, ButtonGroup, Icon, IconSettings, PageHeader, PageHeaderControl} from '@salesforce/design-system-react'

import FormBuilder from './FormBuilder'

const PluginObjectDisplay = () => {
	return (
		<FormBuilder />
	)
}

export default PluginObjectDisplay
